import { render, staticRenderFns } from "./ProductFamilies.vue?vue&type=template&id=52ca1416&"
import script from "./ProductFamilies.vue?vue&type=script&lang=js&"
export * from "./ProductFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports